import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import "./BlogAccount.scss"
const  DeviceList= (props) => {

  const[deviceList, setDeviceList]=useState([]);
  const[loadFailed, setLoadFailed]=useState(false);
   const hostName="/Back-end/getDevice";
  const auth=JSON.parse(sessionStorage.getItem('userData'));
  useEffect(() => {
    // Cette requete partait SANS jeton. Depuis que getDevice exige une
    // authentification (garde anti-IDOR d aout 2026), elle repondait 401 a tous
    // les coups : la liste restait vide et le tableau de bord invitait a
    // « activer mon dispositif » un client qui en possede deja.
    let sessionToken = null;
    try { sessionToken = JSON.parse(sessionStorage.getItem("userData") || "{}").token; } catch (e) {}

    axios
      .get(
        `${hostName}/${auth["user_id"]}`,
        sessionToken ? { headers: { Authorization: `Bearer ${sessionToken}` } } : {}
      )
      .then((reponse) => {
        setDeviceList(Array.isArray(reponse.data) ? reponse.data : []);
        setLoadFailed(false);
      })
      // Un echec ne doit pas se confondre avec « aucun dispositif » : le premier
      // se repare en rechargeant, le second demande une activation.
      .catch(() => setLoadFailed(true));
  }, []);

    return(
        <>
    <div className='device'>
        {loadFailed ?
        <div className="flexAdd">
          <p style={{ margin: 0, color: "#334", textAlign: "center" }}>{props.errorDeviceLoad}</p>
        </div> :
        (deviceList.length===0) ?
        <div className="fa-3x flexAdd">
        <i className="fa-solid fa-circle-plus fa-beat"></i><Link to={`/${props.lang}/MyDevice`} className="linkActive"> {props.textActivate} </Link>
        </div> :
        deviceList.map(d=>{
          return (
              <div >
              <p  style={{padding:"0 15px"}}>  <img src="https://mad-up.com/api/uploads/mad-up/originals/mad-upPRo.svg" alt="mad-up pro" className="imgpro"/>  {d.name} : {d.serial_num}</p>
              <hr/>
              </div>
          )
      }) 
        }
        
      <Link to={`/${props.lang}/MyDevice`}>{props.textDevice} </Link>



</div>      
 
</>
)}
export default DeviceList;